<template>
  <!-- 抽奖记录 -->
  <div>
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left" class="mytable-titleBox">
        <div class="clearfix">
          <FormItem label="用户昵称:" class="fl mytable-title" :label-width="72">
            <Input v-model="formData.username"></Input>
          </FormItem>
          <FormItem label="手机号:" class="fl mytable-title" :label-width="72">
            <Input v-model="formData.phone"></Input>
          </FormItem>
          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleQuery">查询</Button>
            <Button class="fl" @click="handleReset">重置</Button>
          </div>
          <div class="fr" style="margin-top:8px;">
            <span class="allStatistics mr10">
              <em>
                积分
                <b>{{totleNum.integral}}</b>
              </em>
            </span>
             <span class="allStatistics mr10">
              <em>
                欢乐豆
                <b>{{totleNum.bean}}</b>                
              </em>
            </span>
             <span class="allStatistics mr10">
              <em>
                优惠券
                <b>{{totleNum.cash}}</b>  
              </em>
            </span>
          </div>
        </div>

        <div class="line"></div>
        <RadioGroup
          v-model.trim="formData.lottery"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
        >
          <Radio :label="null">全部</Radio>
          <Radio :label="1">积分</Radio>
          <Radio :label="2">欢乐豆</Radio>
          <Radio :label="3">优惠券</Radio>
        </RadioGroup>
        <FormItem label="日期范围:" class="fl mytable-title ml24 mt24" :label-width="72">
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
      </Form>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      totleNum:{},
      vipData: [],
      date: [],
      formData: {
        lottery: null
      },
      formData1: {
        lottery: null
      },
      tableData: [],
      columns: [
        {
          title: "用户昵称",
          key: "username"
        },
        {
          title: "用户头像",
          key: "poster",
          render: (h, params) => {
            return h("img", {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.poster
              }
            });
          }
        },
        {
          title: "手机号",
          key: "phone",
          render:(h,params)=>{
            var phone =params.row.phone?params.row.phone.substr(0, 3) + "****" +params.row.phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "会员等级",
          key: "vip_level"
        },
        {
          title: "奖项",
          key: "lottery",
          align: "center",
          render: (h, params) => {
            let content = "";
            if (params.row.lottery === 3) {
              content = "优惠券";
            } else if (params.row.lottery === 2) {
              content = "欢乐豆";
            } else if (params.row.lottery === 1) {
              content = "积分";
            }
            return h("span", content);
          }
        },
        {
          title: "数值",
          key: "price",
          align: "center"
        },
        {
          title: "抽奖时间",
          key: "create_time"
        }
      ]
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.start_time = val[0];
        this.formData.end_time = val[1];
      } else {
        this.formData.start_time = "";
        this.formData.end_time = "";
      }
      this.handleQuery();
    },
    //会员切换
    handleRefundchange() {
      this.handleQuery();
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.date=[]
      this.handleQuery();
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api
        .prizeRecord({
          ...this.formData,
          page_num: this.page_num,
          page_size: this.page_size
        })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total_row;           
          } else {
            this.$Message.error(res.msg);
          }
          this.tableLoading = false;
        });
        //统计数
        this.$api
        .prizeTotalNum({
          ...this.formData,
          page_num: this.page_num,
          page_size: this.page_size
        })
        .then(res => {
          if (res.code === 0) {
             this.totleNum = res.data;
          } else {
            this.$Message.error(res.msg);
          }
          this.tableLoading = false;
        });
    }
    }
  
};
</script>

<style scoped lang="less">
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
</style>
